export const LangTextA: any = {
    us: {
        title: 'Power Manager',
        desc: `Monitor your power station's battery level to ensure it functions as an uninterrupted power supply (UPS) for critical devices. Receive alerts when the battery level is low.`,
        itemA_1: 'Windows',
        itemB_1: 'Linux',
        itemC_1: 'Mac',
        itemD_1: 'NAS',
        tip: 'Coming soon',
        manual: 'User manual',
        support: 'Supported devices: RIVER 3 Plus',
    },
    it: {
        title: 'Power Manager',
        desc: 'Monitora il livello della batteria della power station per assicurarti che funzioni come gruppo di continuità per i dispositivi critici. Ricevi degli avvisi quando il livello della batteria è basso.',
        itemA_1: 'Windows',
        itemB_1: 'Linux',
        itemC_1: 'Mac',
        itemD_1: 'NAS',
        tip: 'In arrivo',
        manual: 'Manuale utente',
        support: 'Dispositivi supportati: RIVER 3 Plus',
    },
    es: {
        title: 'Power Manager',
        desc: `Monitorice el nivel de batería de tu estación de energía para asegurarse de que funciona como un sistema de alimentación ininterrumpida (SAI) para los dispositivos críticos. Reciba alertas cuando el nivel de la batería sea bajo.`,
        itemA_1: 'Windows',
        itemB_1: 'Linux',
        itemC_1: 'Mac',
        itemD_1: 'NAS',
        tip: 'Próximamente',
        manual: 'Manual de usuario',
        support: 'Dispositivos compatibles: RIVER 3 Plus',
    },
    de: {
        title: 'Power Manager',
        desc: 'Überwachen Sie den Ladezustand der Batterie Ihrer Powerstation, um sicherzustellen, dass sie als unterbrechungsfreie Stromversorgung (USV) für wichtige Geräte funktioniert. Erhalten Sie Warnungen, wenn der Ladezustand der Batterie niedrig ist.',
        itemA_1: 'Windows',
        itemB_1: 'Linux',
        itemC_1: 'Mac',
        itemD_1: 'NAS',
        tip: 'Bald verfügbar',
        manual: 'Benutzerhandbuch',
        support: 'Unterstützte Geräte: RIVER 3 Plus',
    },
    fr: {
        title: 'Power Manager',
        desc: `Surveillez le niveau de batterie de votre station d'alimentation pour vous assurer qu'elle fonctionne comme une alimentation sans interruption (ASI) pour les appareils critiques. Recevez des alertes lorsque le niveau de batterie est faible.`,
        itemA_1: 'Windows',
        itemB_1: 'Linux',
        itemC_1: 'Mac',
        itemD_1: 'NAS',
        tip: 'Bientôt disponible',
        manual: 'Manuel d’utilisation',
        support: 'Appareils pris en charge :  RIVER 3 Plus',
    },
    cn: {
        title: 'Power Manager',
        desc: '电量监控及预警，UPS功能可视化，让您无忧用电，无惧停电。',
        itemA_1: 'Windows',
        itemB_1: 'Linux',
        itemC_1: 'Mac',
        itemD_1: 'NAS',
        tip: '即将发布',
        manual: '用户手册',
        support: '已支持设备：RIVER 3 Plus',
    },
    tw: {
        title: 'Power Manager',
        desc: '電量監控及預警，UPS 功能可視化，讓您無憂用電，無懼停電。',
        itemA_1: 'Windows',
        itemB_1: 'Linux',
        itemC_1: 'Mac',
        itemD_1: 'NAS',
        tip: '即將推出',
        manual: '使用者手冊',
        support: '已支援裝置：RIVER 3 Plus',
    },
    jp: {
        title: 'Power Manager',
        desc: 'ポータブル電源のバッテリー残量を監視して、重要なデバイスの無停電電源装置（UPS）として機能することを確認してください。バッテリー残量が低い場合、警告を受け取ります。',
        itemA_1: 'Windows',
        itemB_1: 'Linux',
        itemC_1: 'Mac',
        itemD_1: 'NAS',
        tip: 'まもなく登場',
        manual: 'ユーザーマニュアル',
        support: '対応デバイス：RIVER 3 Plus',
    },
};
